import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { fadeUp } from "../../lib/motion";
import { useLanguage } from "../../lib/i18n";

export const WeddingFAQ = () => {
  const [open, setOpen] = useState(0);
  const { t } = useLanguage();
  const faqs = t("wfaqs.items");

  return (
    <section data-testid="wedding-faq" className="tiled relative py-8 md:py-10 bg-[--bg]">
      <div className="max-w-[1000px] mx-auto px-5 md:px-10">
        <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} className="font-mono uppercase tracking-[0.3em] text-[11px] text-[--gold] mb-10">{t("wfaqs.eyebrow")}</motion.p>
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-${i}`} className="bg-[--surface] border border-white/10 rounded-2xl overflow-hidden">
                <button onClick={() => setOpen(isOpen ? -1 : i)} className="w-full flex items-center justify-between gap-4 p-6 text-left">
                  <span className="font-display text-lg md:text-xl text-[--text]">{f.q}</span>
                  {isOpen ? <Minus size={18} className="text-[--gold] shrink-0" /> : <Plus size={18} className="text-[--gold] shrink-0" />}
                </button>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35 }} className="overflow-hidden">
                      <p className="px-6 pb-6 text-[--text-2] text-sm leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
